import { USERS } from "../scoro/apiMethods";

export const getUsersRoute = async () => {
  const data = await USERS.list();
  return data;
};
